import { styled, Theme } from "@mui/material";
import Avatar from "@mui/material/Avatar";

interface StyledAvatarProps {
  isPlaceholder?: boolean;
  isHighlighted?: boolean;
  size: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}

const THIN_BORDER_AVATAR_SIZES = ["xs", "s", "m"];

const getAvatarSize = (
  theme: Theme,
  size: "xs" | "s" | "m" | "l" | "xl" | "xxl",
) => `calc(
    ${theme.wsc.spacing[2]} *
      ${
        (size === "xxl" && 6.245) ||
        (size === "xl" && 5) ||
        (size === "l" && 3.75) ||
        (size === "m" && 2.5) ||
        (size === "s" && 1.5) ||
        (size === "xs" && 1)
      }
  )`;

export const StyledAvatar = styled(Avatar, {
  shouldForwardProp: (prop: string) =>
    prop !== "isPlaceholder" && prop !== "isHighlighted",
})<StyledAvatarProps>`
  width: ${({ theme, size }) => getAvatarSize(theme, size)};
  height: ${({ theme, size }) => getAvatarSize(theme, size)};
  background-color: ${({ isPlaceholder, theme }) =>
    isPlaceholder
      ? theme.wsc.palette.neutral[700]
      : theme.wsc.palette.neutral[200]};
  border: ${({ isPlaceholder, isHighlighted, theme, size }) =>
    isPlaceholder || isHighlighted
      ? `${
          THIN_BORDER_AVATAR_SIZES.includes(size) ? "1px" : theme.wsc.radius.s
        } solid ${
          isHighlighted
            ? theme.wsc.palette.success[100]
            : theme.wsc.palette.neutral[600]
        }`
      : "none"};
  z-index: 1;
  transition: all 0.3s ease;
`;
